import styled from "styled-components";

const TextStyles = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  .bold {
    font-weight: bold;
  }

  .yellow {
    color: #fde704;
  }

  .centred-text {
    text-align: center;
  }

  span {
    font-weight: bolder;
  }

  h2 {
    font-family: "Titillium Web", sans-serif;
    font-size: 24px;
    letter-spacing: 3px;
    text-align: center;
    color: #fde704;
    text-shadow: 1px 1px #000000;
    padding: 10px 0;
  }

  h3 {
    text-align: left;
    padding: 5px;
    font-size: 18px;
  }

  h4 {
    font-size: 18px;
    color: #fde704;
    letter-spacing: 2px !important;
  }

  a {
    color: #fde704 !important;
    text-decoration: none !important;
  }

  a:hover {
    color: #fde704 !important;
    text-decoration: underline !important;
  }

  ul {
    padding-left: 15px;
  }

  p,
  li {
    text-shadow: 1px 1px black;
    font-size: 16px;
    color: white;
    text-align: justify;
  }

  li {
    margin: 5px 0;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    margin-bottom: 20px;
    padding: 0 5vw;

    h2 {
      font-size: 21px;
      letter-spacing: 2px;
    }

    h3 {
      font-size: 15px !important;
    }

    p,
    li {
      text-align: left;
      font-size: 14px;
    }
  }
`;

export default TextStyles;



// WEBPACK FOOTER //
// ./src/components/universal-styles/TextStyles.js